import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../../helpers/handleError";
import { puedeCobrarSenas } from "../../../helpers/senasOrganizer";
import SpinLoading from "../../../components/spinLoading/SpinLoading";
import GuidedFlow from "../../primerUso/GuidedFlow";
import { datosInicialesEvento } from "./eventoPayload";
import { pasosEvento } from "./eventoPasos";
import { cargarCatalogos, crearEvento, guardarOpcional } from "./eventoServicios";

const MODULO = {
  nombre: "Eventos",
  publicado: "Tu evento ya está publicado.",
  resumenReq: "Datos del evento, dirección y entradas",
};

// Where each optional section lives once the event exists: the event form or the section's own screen.
const RUTA_SECCION = { cupones: "/organizer/coupons", difusion: "/organizer/sponsors" };

/**
 * "Crear evento" (events/new): required steps create the event with the same payload as EventForm,
 * optional steps then complete it through the existing endpoints. Editing keeps EventForm.
 */
const EventGuidedFlow = () => {
  const navigate = useNavigate();
  const negocio = useSelector((s) => s.auth)?.negocio?.nombre || "";
  const [catalogos, setCatalogos] = useState(null);

  useEffect(() => {
    cargarCatalogos().then(setCatalogos).catch((e) => { handleError(e); setCatalogos({ categorias: [], provincias: [], me: null }); });
  }, []);

  const me = catalogos?.me;
  const soloGratis = String(me?.organizerType || "").toUpperCase() === "FREE_ONLY" || !puedeCobrarSenas(me);
  const avisoGratis = me?.capability?.message
    || "Esta cuenta solo puede organizar eventos gratis. Para vender entradas necesitás tus cobros validados en ZOCO Pagos.";

  const pasos = useMemo(
    () => (catalogos ? pasosEvento({ categorias: catalogos.categorias, provincias: catalogos.provincias, soloGratis, avisoGratis }) : null),
    [catalogos, soloGratis, avisoGratis]
  );
  const datosIniciales = useMemo(() => datosInicialesEvento(negocio), [negocio]);

  if (!pasos) return <SpinLoading />;

  const irSeccion = (paso, ctx) => {
    const to = RUTA_SECCION[paso.id] || `/organizer/events/${ctx.id}`;
    navigate(to, to.includes("/events/") ? { state: { event: ctx.event } } : undefined);
  };

  return (
    <GuidedFlow
      modulo={MODULO}
      pasosReq={pasos.req}
      pasosOpc={pasos.opc}
      datosIniciales={datosIniciales}
      onPublicar={(d) => crearEvento(d, { soloGratis })}
      onGuardarOpc={guardarOpcional}
      onIrSeccion={irSeccion}
      onIrModulo={() => navigate("/organizer/events")}
      onCancelar={() => navigate("/organizer/events")}
      extrasCierre={[{
        titulo: "Diplomas para ganadores",
        sub: "Se eligen entre los asistentes cuando termina el evento, desde el formulario del evento.",
      }]}
    />
  );
};

export default EventGuidedFlow;
